import apiFetch from '../../apiFetch'

export default function (token, purchaseId, campaignId, parentIsHistorical, lastAccessDate, percentage) {
  return apiFetch({ endPoint: `dossier/purchase/${purchaseId}/ReassignToCampaign/${campaignId}?parentIsHistorical=${parentIsHistorical}&percentageCampaignRequested=${percentage}`, method: 'PUT', body: null, token: token, lastAccessDate })
}
